import React, { useState, useEffect } from 'react';

const DOCS = [
  { key: 'doc_identificaciones', label: 'Identificaciones' },
  { key: 'doc_actas_nacimiento', label: 'Actas Nacimiento' },
  { key: 'doc_acta_matrimonio', label: 'Acta Matrimonio' },
  { key: 'doc_curp', label: 'CURP' },
  { key: 'doc_carta_laboral', label: 'Carta Laboral' },
  { key: 'doc_reporte_semanas_cotizadas', label: 'Reporte Semanas Cotizadas' },
  { key: 'doc_recibos_nomina', label: 'Recibos Nomina' },
  { key: 'doc_constancia_situacion_fiscal', label: 'Constancia Situación Fiscal' },
  { key: 'doc_estados_cuenta_personales', label: 'Estados de Cuenta Personales' },
  { key: 'doc_acta_constitutiva_empresa', label: 'Acta Constitutiva Empresa' },
  { key: 'doc_constancia_situacion_fiscal_empresa', label: 'Constancia de Situación Fiscal de Empresa' },
  { key: 'doc_estados_cuenta_empresa', label: 'Estados de Cuenta de Empresa' },
  { key: 'doc_declaracion_acuse_impuestos_empresa', label: 'Declaración y Acuse Impuestos Empresa' },
  { key: 'doc_ultimo_estado_cuenta_credito_hipotecario', label: 'Ultimo Estado de Cuenta de Credito Hipotecario' },
];

const stBase = {
  title: { fontSize: 15, fontWeight: 'bold', color: '#1a3a6e', marginBottom: 8, borderBottom: '2px solid #FFC107', paddingBottom: 5 },
  field: { marginBottom: 8 },
  label: { display: 'block', fontSize: 12, fontWeight: '600', color: '#374151', marginBottom: 4 },
  select: { width: '100%', height: 32, padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', resize: 'none', fontFamily: 'inherit' },
  saveBtn: { backgroundColor: '#1a3a6e', color: 'white', border: 'none', padding: '10px 20px', borderRadius: 6, fontSize: 14, fontWeight: '600', cursor: 'pointer', marginTop: 6 },
  docRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 8px', borderRadius: 4 },
  docRowEven: { backgroundColor: '#ffffff' },
  docRowOdd: { backgroundColor: '#e3e7ec' },
  docLabel: { fontSize: 12.5, color: '#374151' },
  docSelect: { width: 100, height: 26, padding: '2px 6px', border: '1px solid #d1d5db', borderRadius: 5, fontSize: 12 },
  docSelectOk: { backgroundColor: '#dcfce7' },
  docSelectFalta: { backgroundColor: '#fee2e2' },
  docSelectNA: { backgroundColor: '#fef9c3' },
  headerRow: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8, flexWrap: 'wrap' },
  badge: { display: 'inline-block', padding: '3px 12px', borderRadius: 20, fontSize: 12.5, fontWeight: '700' },
  badgeCompleto: { backgroundColor: '#dcfce7', color: '#166534' },
  badgeIncompleto: { backgroundColor: '#fee2e2', color: '#991b1b' },
  fecha: { fontSize: 12, color: '#6b7280', marginTop: 8 },
  charCount: { fontSize: 11, color: '#6b7280', marginTop: 3, textAlign: 'right' },
};

const fmtFecha = (iso) => {
  if (!iso) return '';
  const d = new Date(iso + (iso.length === 10 ? 'T00:00:00' : ''));
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const StatusProspecto = ({ prospectoId, formData, setFormData }) => {
  const API = '/api';
  const st = {
    ...stBase,
    card: { width: '100%', maxWidth: 840, backgroundColor: '#F0F0F0', padding: 14, borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: 14 },
  };
  const [status, setStatus] = useState({});

  useEffect(() => {
    if (!prospectoId) return;
    fetch(`${API}/prospecto-status/${prospectoId}`)
      .then(r => r.ok ? r.json() : null)
      .then(datos => {
        if (datos && datos.id) {
          setStatus(datos);
          setFormData(prev => ({ ...prev, status: datos }));
        }
      })
      .catch(e => console.error('Error cargando Status del prospecto:', e));
  }, [prospectoId]);

  const set = (campo, valor) => {
    const nuevo = { ...status, [campo]: valor };
    setStatus(nuevo);
    setFormData(prev => ({ ...prev, status: nuevo }));
  };

  const guardar = async () => {
    if (!prospectoId) {
      alert('Primero debe guardar el prospecto antes de capturar el Status');
      return;
    }
    try {
      const res = await fetch(`${API}/prospecto-status/${prospectoId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(status),
      });
      const data = await res.json();
      if (data.success) {
        alert('✓ Status guardado correctamente');
        const actualizado = await fetch(`${API}/prospecto-status/${prospectoId}`).then(r => r.json());
        setStatus(actualizado);
        setFormData(prev => ({ ...prev, status: actualizado }));
      } else {
        alert('Error: ' + data.error);
      }
    } catch (e) {
      alert('Error al guardar el Status');
    }
  };

  const statusDocumentosCalculado = DOCS.every(d => {
    const v = status[d.key] || 'Falta';
    return v === 'Ok' || v === 'N/A';
  }) ? 'Completo' : 'Incompleto';

  return (
    <div>
      <div style={st.card}>
        <h3 style={st.title}>Check-list de Documentos</h3>
        <div style={st.headerRow}>
          <span style={{ ...st.badge, ...(statusDocumentosCalculado === 'Completo' ? st.badgeCompleto : st.badgeIncompleto) }}>
            Status: {statusDocumentosCalculado}
          </span>
        </div>
        <div>
          {DOCS.map((d, i) => (
            <div key={d.key} style={{ ...st.docRow, ...(i % 2 === 0 ? st.docRowEven : st.docRowOdd) }}>
              <span style={st.docLabel}>{d.label}</span>
              <select
                value={status[d.key] || 'Falta'}
                onChange={e => set(d.key, e.target.value)}
                style={{
                  ...st.docSelect,
                  ...(status[d.key] === 'Ok' ? st.docSelectOk
                    : status[d.key] === 'N/A' ? st.docSelectNA
                    : st.docSelectFalta),
                }}
              >
                <option value="Ok">Ok</option>
                <option value="N/A">N/A</option>
                <option value="Falta">Falta</option>
              </select>
            </div>
          ))}
        </div>
        {status.status_documentos_fecha && (
          <div style={st.fecha}>Última actualización: {fmtFecha(status.status_documentos_fecha)}</div>
        )}
      </div>

      <div style={st.card}>
        <h3 style={st.title}>Observaciones</h3>
        <div style={st.field}>
          <textarea
            rows={3}
            maxLength={150}
            value={status.observaciones || ''}
            onChange={e => set('observaciones', e.target.value)}
            style={st.textarea}
            placeholder="Observaciones (máx. 150 caracteres)"
          />
          <div style={st.charCount}>{(status.observaciones || '').length}/150</div>
        </div>
        {status.observaciones_fecha && (
          <div style={st.fecha}>Última observación: {fmtFecha(status.observaciones_fecha)}</div>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={guardar} style={st.saveBtn}>💾 Guardar Status</button>
      </div>
    </div>
  );
};

export default StatusProspecto;
